<template>
  <a-layout-header class="hm-web-header hm-web-header_h5">
    <div class="hm-web-header__menu">
      <div class="main">
        <div class="logo" @click.stop="gotoHome">
          <hmImg imgName="home_logo_01_zh" imgClass="hm-logo"/>
        </div>
        <div class="hm-web-header__menu-actions">
          <a-dropdown class="langue-tools" :trigger="['click']">
            <span>{{langueLabel}} <a-icon type="down" class="down-icon" style="" /></span>
            <a-menu slot="overlay" :selectedKeys="[langue]" @click="onToggleLeague">
              <a-menu-item v-for="(value, key) in langueMap" :key="value">
                {{ key }}
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <div class="home-menu-icon-wrap" @click="onClickMenuIcon">
            <hmImg imgName="home_menu_iconHover" imgClass="home-menu-icon" v-if="ifShowMenu"/>
            <hmImg imgName="home_menu_icon" imgClass="home-menu-icon" v-else/>
          </div>
        </div>
      </div>
      <hmMenuH5 v-if="ifShowMenu" class="hm-menu-h5-wrap" @menuChange="menuChange" />
    </div>
    <!-- <div class="hm-apply-entry" @click.stop="goToApply">
      <span class="hm-apply-entry__label">申请试用华盟税纪云</span>
      <span class="hm-apply-entry__action">免费试用<a-icon type="right" class="action-icon" /></span>
    </div> -->
  </a-layout-header>
</template>

<script>
import hmMenuH5 from '@/components/hm-menu/index_h5.vue'

export default {
  components: { hmMenuH5 },
  name: 'headerH5',
  data () {
    return {
      langue: 'zh',
      langueMap: {
        '中': 'zh'
        // 'En': 'en',
        // '日本语': 'jp'
      },
      ifShowMenu: false
    }
  },
  computed: {
    langueLabel ({ langueMap, langue }) {
      let target = ''
      for (const key in langueMap) {
        if (langueMap[key] === langue) {
          target = key
        }
      }
      return target
    }
  },
  watch: {
    ifShowMenu (flag) {
      this.toggleDocBodyOverflow(flag)
    }
  },
  methods: {
    gotoHome () {
      this.$router.push({ name: 'home' })
      this.ifShowMenu = false
    },
    onClickMenuIcon () {
      this.ifShowMenu = !this.ifShowMenu
      console.log('%c点击菜单', 'background-color: green;color: #fff;', this.ifShowMenu)
    },
    onToggleLeague ({ item, key, selectedKeys }) {
      console.log('%conToggleLeague', 'background-color: green;color: #fff;', item, key, selectedKeys)
      this.langue = key
    },
    menuChange () {
      this.ifShowMenu = false
    },
    toggleDocBodyOverflow (flag) {
      document.body.style.overflow = flag ? 'hidden' : 'auto'
    }
  }
}
</script>

<style lang="less">
#hm-web {
  .hm-web-header_h5 {
    width: 100%;
    height: 98px;
    line-height: 98px;
    box-shadow: 0px 2px 6px 0px rgba(196,211,237,0.5);
    .hm-web-header__menu {
      height: 100%;
      line-height: 98px;
      padding: 0 40px;
      .main {
        justify-content: space-between;
      }
    }
    .logo {
      width: 144px;
    }
    .hm-logo {
      width: auto;
      height: 66px;
    }
    .hm-web-header__menu-actions {
      display: flex;
      height: 98px;
      line-height: 98px;
    }
    .langue-tools {
      display: block;
      margin-right: 56px;
      font-size: 28px;
      cursor: pointer;
      .down-icon{
        font-size: 24px;
        color: #848D9E;
      }
    }
    .home-menu-icon-wrap {
      width: 48px;
      height: 48px;
      cursor: pointer;
    }
    .home-menu-icon {
      width: 48px;
      height: 48px;
    }
    .hm-menu-h5-wrap {
      position: absolute;
      top: 98px;
      left: 0;
      height: 100vh;
      width: 100vw;
      background-color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/header/index_h5.vue